import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ColorSelectModule } from "src/app/components/color-select/color-select.module";
import { EventContentsPageRoutingModule } from "./event-contents-routing.module";
import { EventContentsPage } from "./event-contents.page";
import { EventResponseModule } from "src/app/pipes/event-response/event-response.module";
import { LogoModule } from "src/app/components/logo/logo.module";
import { FilterContentsModule } from "./pipes/filter-contents/filter-contents.module";
import { TranslateModule } from "@ngx-translate/core";
import { MapModulesModule } from "./pipes/map-modules/map-modules.module";
import { PopoverModule } from "src/app/components/popover/popover.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    EventContentsPageRoutingModule,
    ColorSelectModule,
    EventResponseModule,
    FilterContentsModule,
    LogoModule,
    TranslateModule,
    MapModulesModule,
    PopoverModule,
  ],
  providers: [],
  declarations: [EventContentsPage],
})
export class EventContentsPageModule {}
